import React, { JSX } from "react";
import { useState, useEffect, useRef } from "react";
import { Form, Stack } from "react-bootstrap";
import { SXBackground } from "./SXBackground";
import {
  Accordion,
  Button,
  ButtonGroup,
  ButtonToolbar,
  Col,
  Container,
  Dropdown,
  ListGroup,
  Nav,
  Navbar,
  OverlayTrigger,
  Row,
  Tab,
  Tabs,
  Tooltip,
} from "react-bootstrap";
import SXMobileWarning from "./SXMobileWarning";
import { useTrialRedirect } from "./SXTrialButton";
import LoginButton from "./LoginButton";
import { useTranslation } from "react-i18next";

export function SXIntroScreen(props: {
  config?: any;
  useauth0?: any;
  errorMsg?: string;
  trailTag: string;
}): JSX.Element {
  const [, TrialVersionButton] = useTrialRedirect();
  const { loginWithRedirect, logout, isAuthenticated, isLoading } = props.useauth0();
  const { t } = useTranslation();
  return (
    <>
      <Container fluid id="app_container">
        {/* Top Navigation Bar */}
        <Navbar id="top-nav-bar" className="top-nav-bar-bg">
          <Nav className="me-auto"></Nav>
          <Nav></Nav>
          <Nav></Nav>
          <Nav>
            <Nav.Link className="nav-link"></Nav.Link>
          </Nav>
          <Nav></Nav>
        </Navbar>
        {/* This is the offcanvas menu that will be shown when the user clicks on UserInitialsIcon */}
        {/* Main Application Row */}

        <Row id="main-app-row" style={{ height: "100%", position: "relative", zIndex: 10 }}>
          <SXBackground />
          <Col id="main-app-col" className="d-flex flex-column align-items-center justify-content-center">
            <>
              <Container className="welcome-panel">
                <Row className="align-items-center justify-content-center m-4 title-row">
                  <Col xs={12} className="text-center">
                    <h1>{t("welcome_to_simplex_column_.label")}</h1>
                  </Col>
                </Row>

                <Row className="p-0 m-0">
                  <Col md={8} xs={12} className="m-0">
                    <Row>
                      <Col md={6} xs={12} className="m-0">
                        <Stack className="text-center m-0">
                          <h1>{t("sign_up_.label")}</h1>
                          <div className="m-0 p-0 welcome-box-content ">
                            <Col className="mt-1 mb-1 p-3 welcome-box flash-card">
                              <Row
                                className="align-items-center justify-content-center center-content"
                                style={{ height: 208 }}
                              >
                                <Col xs={12}>
                                  <h3>{t("new_user_.label")}</h3>
                                </Col>
                                {/* @ts-ignore */}
                                <TrialVersionButton
                                  hint={true}
                                  config={{}}
                                  loginWithRedirect={loginWithRedirect}
                                  trialTag={props.trailTag}
                                />
                                <Col xs={12} className="text-center">
                                  <p>
                                    <small>{t("if_you_dont_have_a_strusoft_portal_account_.label")}</small>
                                  </p>
                                </Col>
                              </Row>
                            </Col>

                            <Col className="mt-3 mb-1 p-3 welcome-box flash-card">
                              <Row
                                className="align-items-center justify-content-center center-content"
                                style={{ height: 208 }}
                              >
                                <Col xs={12}>
                                  <h3>{t("existing_account_.label")}</h3>
                                </Col>
                                {/* @ts-ignore */}
                                <TrialVersionButton
                                  hint={false}
                                  config={{}}
                                  loginWithRedirect={loginWithRedirect}
                                  trialTag={props.trailTag}
                                />

                                <Col xs={12} className="pt-1 text-center">
                                  <p>
                                    <small>{t("if_you_have_a_strusoft_portal_account_.label")}</small>
                                  </p>
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        </Stack>
                      </Col>

                      <Col md={6} xs={12} className="m-0">
                        <Stack className="text-center m-0">
                          <h1>&nbsp;</h1>
                          <Col className="mt-1 mb-1 p-3 welcome-box text-center">
                            <Container className="m-0 p-0" style={{ overflow: "scroll" }}>
                              <strong>{t("trial_faq_.label")}</strong>
                              <hr />
                              <Row className="mb-3" style={{ overflow: "auto" }}>
                                <Col>
                                  <strong>{t("when_does_the_trial_start_.label")}</strong>
                                  <div>{t("immediately_.label")}</div>
                                </Col>
                              </Row>
                              <Row className="mb-3">
                                <Col>
                                  <strong>{t("how_long_is_the_trial_.label")}</strong>
                                  <div>{t("two_weeks_.label")}</div>
                                </Col>
                              </Row>
                              <Row className="mb-3">
                                <Col>
                                  <strong>{t("is_the_trial_free_.label")}</strong>
                                  <div>{t("yes_no_credit_card_required_.label")}</div>
                                </Col>
                              </Row>
                              <Row className="mb-3">
                                <Col>
                                  <strong>{t("how_long_does_it_take_to_complete_the_forms_.label")}</strong>
                                  <div>{t("about_30_seconds_you_will_be_inside_the_software_right_away_.label")}</div>
                                </Col>
                              </Row>
                              <Row className="mb-3">
                                <Col>
                                  <strong>{t("what_if_i_have_an_issue_or_cant_log_in_.label")}</strong>
                                  <div>
                                    <a href="https://strusoft.freshdesk.com/en/support/home">
                                      {t("contact_support_.label")}
                                    </a>
                                    .
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mb-3">
                                <Col>
                                  <strong>{t("how_many_trials_can_i_have_.label")}</strong>
                                  <div>{t("one_trial_per_user_.label")}</div>
                                </Col>
                              </Row>
                            </Container>
                          </Col>
                        </Stack>
                      </Col>
                    </Row>
                  </Col>

                  <Col md={4} xs={12} className="m-0 ">
                    <Stack className="text-center m-0">
                      <h1>{t("sign_in_.label")}</h1>
                      <div className="m-0 p-0 welcome-box-content ">
                        <Col className="welcome-box hover-card">
                          <Row
                            className="align-items-center justify-content-center center-content row"
                            style={{ height: 500 }}
                          >
                            <Col xs={12} style={{ padding: 0, marginTop: 0 }}>
                              <h3>{t("welcome_back_.label")}</h3>
                              <br />{" "}
                              <LoginButton
                                className="btn  login-btn trial-btn"
                                id={"loginbutton"}
                                isLoading={isLoading}
                                isAuthenticated={isAuthenticated}
                                loginWithRedirect={loginWithRedirect}
                                logout={logout}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    </Stack>
                  </Col>
                </Row>

                <Row className="align-items-center justify-content-center">
                  <Col xs={2} className="text-center pt-5">
                    <div className="strusoft-svg-logo-box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ fill: "#3c74a8" }}
                        viewBox="0 0 214.7 44.4"
                        className="strusoft-svg-logo"
                      >
                        <g>
                          <path d="m22.4,9.2c-1.8-1.2-4.3-2.4-6.7-2.4-3.5,0-5.4,1.9-5.4,4.4,0,2.7,2.9,4.8,7.7,8.6,5.6,4.4,8.5,7.9,8.5,13s-5,11.2-14.3,11.2c-4.3,0-9.1-1.3-12.2-4.1l3-4.7c2.2,1.6,4.7,3.3,8.4,3.3,3.4,0,6.4-1.8,6.4-5.7,0-4.5-5.6-7.6-8.9-10.2-4-3.2-7.4-5.8-7.4-11.3S7.1,1.3,14.6,1.3c4.7,0,8.5,1.7,10.5,3.6l-2.7,4.3Z" />
                          <path d="m40.4,14.2h7v4h-7v14.5c0,4.8,1.5,6.9,4.1,6.9,1.7,0,2.7-.5,3.8-1l1.4,3.9c-2.3,1.2-5.1,1.9-7.7,1.9-6.5,0-9.3-3.4-9.3-9.4v-16.8h-4.3v-4h4.1v-7.1l7.9-1.8v8.9Z" />
                          <path d="m62.2,19.1h.1l1.6-2.3c.9-1.2,2.7-3.6,5.1-3.6,1.8,0,3.7.9,5.3,2.7l-3,5.4c-1.3-.6-2.1-1-3.7-1-2.7,0-5.4,2.2-5.4,8.6v14.5h-7.8V13.4h7.8v5.7Z" />
                          <path d="m95.5,39.3c-2.8,2.8-5.4,4.4-9.1,4.4-6.3,0-10-3.8-10-11.2V13.4h7.9v17.9c0,4.1,1.8,6.8,5.6,6.8,2.7,0,5.6-2.3,5.6-7.7V13.4h9v30h-8.9v-4.1h-.1Z" />
                          <path d="m131.5,9.2c-1.8-1.2-4.3-2.4-6.7-2.4-3.5,0-5.4,1.9-5.4,4.4,0,2.7,2.9,4.8,7.7,8.6,5.5,4.4,8.5,7.9,8.5,13s-5,11.2-14.3,11.2c-4.3,0-9.1-1.3-12.2-4.1l3-4.7c2.2,1.6,4.7,3.3,8.4,3.3,3.4,0,6.4-1.8,6.4-5.7,0-4.5-5.5-7.6-8.9-10.2-4-3.2-7.4-5.8-7.4-11.3s5.6-10,13.1-10c4.7,0,8.5,1.7,10.5,3.6l-2.7,4.3Z" />
                          <path d="m139.5,28.5c0-9.6,7.6-15.1,15.5-15.1s15.5,5.5,15.5,15.1-6.3,15.8-15.5,15.8c-9.3,0-15.5-6.6-15.5-15.8Zm22.6,0c0-4.9-1.7-10.7-7.2-10.7s-7.1,5.8-7.1,10.7c0,5.2,1.5,11.5,7.1,11.5s7.2-6.3,7.2-11.5Z" />
                          <path d="m176.4,43.4v-25h-5v-5h5v-2.9c0-7.7,5.5-10.5,9.9-10.5,1.8,0,4.1.2,6.1,1.3l-1.4,3.9c-1.1-.4-2.2-.5-3.4-.5s-3.4.7-3.4,4.4v4.3h7v5h-7v25h-7.8Z" />
                          <path d="m205.4,14.2h8v4h-8v14.5c0,4.8,1.5,6.9,4.1,6.9,1.7,0,2.7-.5,3.8-1l1.4,3.9c-2.3,1.2-5.1,1.9-7.7,1.9-6.5,0-9.3-3.4-9.3-9.4v-16.8h-4.3v-4h4.1v-7.1l7.9-1.8v8.9Z" />
                        </g>
                      </svg>
                    </div>
                  </Col>
                </Row>
              </Container>

              <br />
              <br />
            </>
            {props.errorMsg && <div className="error-message">{props.errorMsg}</div>}
          </Col>
        </Row>
      </Container>
    </>
  );
}
